<template>
    <component
        :is="previewComponent"
        :meta-overwrites="props.metaOverwrites"
        :master-template="props.masterTemplate"
        @setInStreamValue="(value: boolean) => emit('setInStreamValue', value)"
    >
        <slot />
    </component>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { MasterTemplate } from "shared-types";
import { META_AD_PREVIEW_TYPE, type MetaAdPreviewType } from "@/enums/adPreview";

import FacebookInStreamFull from "@/components/Campaign/AdPreview/FacebookInStreamFull.vue";
import FacebookNewsFeed from "@/components/Campaign/AdPreview/FacebookNewsFeed.vue";
import FacebookStory from "@/components/Campaign/AdPreview/FacebookStory.vue";
import FacebookReel from "@/components/Campaign/AdPreview/FacebookReel.vue";
import InstagramStory from "@/components/Campaign/AdPreview/InstagramStory.vue";
import InstagramReel from "@/components/Campaign/AdPreview/InstagramReel.vue";
import InstagramFeed from "@/components/Campaign/AdPreview/InstagramFeed.vue";
import FacebookInStream from "@/components/Campaign/AdPreview/FacebookInStream.vue";

import type { MetaOverwrites } from "@/types/types";

const componentMap = {
    [META_AD_PREVIEW_TYPE.NEWS_FEED]: FacebookNewsFeed,
    [META_AD_PREVIEW_TYPE.NEWS_FEED_DESKTOP]: FacebookNewsFeed,
    [META_AD_PREVIEW_TYPE.NEWS_FEED_VIDEO]: FacebookNewsFeed,
    [META_AD_PREVIEW_TYPE.NEWS_FEED_TAB]: FacebookNewsFeed,
    [META_AD_PREVIEW_TYPE.FACEBOOK_REEL_MOBILE]: FacebookReel,
    [META_AD_PREVIEW_TYPE.FACEBOOK_REEL]: FacebookReel,
    [META_AD_PREVIEW_TYPE.FACEBOOK_STORY]: FacebookStory,
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_VIDEO_MOBILE]: FacebookInStream,
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_VIDEO_DESKTOP]: FacebookInStream,
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_BANNER_MOBILE]: FacebookInStream,
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_BANNER_DESKTOP]: FacebookInStream,
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_FULL_VIDEO]: FacebookInStreamFull,
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_FULL_BANNER]: FacebookInStreamFull,
    [META_AD_PREVIEW_TYPE.INSTAGRAM_STORY]: InstagramStory,
    [META_AD_PREVIEW_TYPE.INSTAGRAM_FEED]: InstagramFeed,
    [META_AD_PREVIEW_TYPE.INSTAGRAM_REEL]: InstagramReel
} as Record<MetaAdPreviewType, object>;

const props = defineProps<{
    metaOverwrites: MetaOverwrites;
    masterTemplate: MasterTemplate;
    adPreviewType: MetaAdPreviewType;
}>();

const previewComponent = computed(() => componentMap[props.adPreviewType]);

const emit = defineEmits(["setInStreamValue"]);
</script>
